const NUMBER_OF_SHOP_COLUMNS = 4;
const NUMBER_OF_SHOP_ROWS = 2;
const ITEMS_PER_PAGE = NUMBER_OF_SHOP_COLUMNS * NUMBER_OF_SHOP_ROWS;
const ITEMS_PER_PAGE_DESIGNS = NUMBER_OF_SHOP_COLUMNS * NUMBER_OF_SHOP_ROWS;

export {
  NUMBER_OF_SHOP_COLUMNS,
  NUMBER_OF_SHOP_ROWS,
  ITEMS_PER_PAGE,
  ITEMS_PER_PAGE_DESIGNS,
};
